<ion-item-group>
  <ion-item-divider>
    <ion-label>Arquivos</ion-label>
    <ion-toolbar>
      <ion-buttons slot="primary">
        <ion-fab-button size="small" color="success"  (click)="getFoto(CameraSource.Camera)">
          <ion-icon name="camera"></ion-icon>
        </ion-fab-button>
        <ion-fab-button size="small" color="success"  (click)="getFoto(CameraSource.Photos)">
          <ion-icon name="folder"></ion-icon>
        </ion-fab-button>
        <ion-fab-button color="success"  disabled="true" size="small">
          <ion-icon name="videocam"></ion-icon>
        </ion-fab-button>
        <ion-fab-button color="success"  disabled="true" size="small">
          <ion-icon name="recording"></ion-icon>
        </ion-fab-button>

      </ion-buttons>
    </ion-toolbar>
  </ion-item-divider>
  <ion-item-sliding *ngFor="let met of _entidades">
    <ion-item (click)="edit(met)">
<!--      <ion-text>{{ met.caminho }}</ion-text>-->
      <ion-img [src]="met.url"></ion-img>
    </ion-item>
    <ion-item-options>
      <ion-item-option>
        <ion-icon  color="danger" (click)="delete(met)" size="small" slot="icon-only" name="trash"></ion-icon>
      </ion-item-option>
    </ion-item-options>
  </ion-item-sliding>
</ion-item-group>
